export default __webpack_public_path__ + "static/devices-682f51d06fed65114d9e2b9ac7310125.png";